import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { pathData } from './path-data';

export const ReemaIconComponent = (props: SvgIconProps) => {
  const viewBox = '0 0 126 124';

  return (
    <SvgIcon {...props} viewBox={viewBox}>
      <path d={pathData} fill="currentColor" />
    </SvgIcon>
  );
};
